import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APIConstants } from '../../../../_config/restapis';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { logger } from '../../../../_helpers/Logger/Logger.class';

@Injectable()
export class APITelemarketerHeaderRegistration {

    constructor(
        private http: HttpClient
    ) { }

	 public getcategory(): Observable<any> {
        // return this.http.get(APIConstants.GETCATEGORY);
		return this.http.get(APIConstants.GETCATEGORY)
            .pipe(
                map((res) => this.parseResponse(res)),
                catchError(this.HandleError())
            );
    }

   

    private HandleError(): any {

    }

    private parseResponse(res): any {
        var _modRes = [];

        for (let i = 0; i < res.length; i++) {
            let obj = res[i];
            if (Object.keys(obj.Record).length < 3) {
                obj["child"] = [];
                for (let j = 0; j < res.length; j++) {
                    const elm = res[j].Record.PrefcatID;
                    if (obj.Key === elm && Object.keys(res[j].Record).length > 2)
                        obj.child.push(res[j]);
                }
                _modRes.push(obj);
            }
        }
        return _modRes;
    }
}
